import { Box, Tab, Tabs, useTheme } from "@mui/material";
import { useState } from "react";
import DescriptionTab from "./courseDetails/Tabs/Descriptiontab";
import ContentTab from "./courseDetails/Tabs/ContentTab";
import ReviewsTab from "./courseDetails/Tabs/ReviewTab";
import InstructorTab from "./courseDetails/Tabs/InstructorTab";
import FaqTab from "./courseDetails/Tabs/FaqTab";
import DiscussionsTab from "./courseDetails/Tabs/DiscussionTab";
import ResourcesTab from "./courseDetails/Tabs/ResourcesTab";

export default function CourseTabs({ data, metadata }) {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  console.log("Course metadata in CourseTabs:", metadata);

  const handleChange = (e, v) => setValue(v);

  return (
    <Box sx={{ background: theme.palette.background.paper, borderRadius: 2, p: 2 }}>
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{ borderBottom: `1px solid ${theme.palette.divider}`, mb: 2 }}
        variant="scrollable"
      > 
        <Tab label="Description" />
        <Tab label="Content" />
        <Tab label="Reviews" />
        <Tab label="Instructor" />
        <Tab label="FAQs" />
        <Tab label="Discussions" />
        <Tab label="Resources" />
      </Tabs>

      {value === 0 && <DescriptionTab data={data} />}
      {value === 1 && <ContentTab data={metadata}  />}
      {value === 2 && <ReviewsTab  />}
      {value === 3 && <InstructorTab data={data} />}
      {value === 4 && <FaqTab data={data}/>}
      {value === 5 && <DiscussionsTab  />}
      {value === 6 && <ResourcesTab data={data} />}
    </Box>
  );
}
